import type { ComparatorType } from '../../types';
import { NUMERIC_FILTER_TYPES, type ReportTypeViewFieldBooleanFilter, type ReportTypeViewFieldEquipmentFilter, type ReportTypeViewFieldNumericFilter, type ReportTypeViewFieldOtherFilter, type ReportTypeViewFieldSignatureFilter, type ReportTypeViewFieldTextualFilter } from '../../types';

export type SecondaryTextual = { value: ReportTypeViewFieldTextualFilter['value']; comparator: ReportTypeViewFieldTextualFilter['comparator']; type: ReportTypeViewFieldTextualFilter['type']; };

export type SecondaryBoolean = { value: ReportTypeViewFieldBooleanFilter['value']; comparator: ReportTypeViewFieldBooleanFilter['comparator']; type: ReportTypeViewFieldBooleanFilter['type']; };

export type SecondaryNumeric =
	| {
		value: { min: Nullable<number>; max: Nullable<number>; }; // can't do ReportTypeViewFieldBooleanFilter['value'] since TS is stupid and doesn't transfer discriminated union types
		comparator: ComparatorType.RANGE;
		type: ReportTypeViewFieldNumericFilter['type'];
	}
	| {
		value: Nullable<number>;
		comparator: ComparatorType.LESS_OR_EQUAL
		| ComparatorType.EQUAL
		| ComparatorType.GREATER
		| ComparatorType.GREATER_OR_EQUAL
		| ComparatorType.NOT_EQUAL
		| ComparatorType.LESS
		| ComparatorType.EMPTY;
		type: ReportTypeViewFieldNumericFilter['type'];
	};
export type SecondarySignature = { value: ReportTypeViewFieldSignatureFilter['value']; comparator: ReportTypeViewFieldSignatureFilter['comparator']; type: ReportTypeViewFieldSignatureFilter['type']; };

export type SecondaryEquipment = { value: ReportTypeViewFieldEquipmentFilter['value']; comparator: ReportTypeViewFieldEquipmentFilter['comparator']; type: ReportTypeViewFieldEquipmentFilter['type']; };

export function isSecondaryNumeric(
	filter: SecondaryFilter
): filter is SecondaryNumeric {
	return NUMERIC_FILTER_TYPES.includes(filter.type as typeof NUMERIC_FILTER_TYPES[number]);
}

type SecondaryOther = { value: ReportTypeViewFieldOtherFilter['value']; comparator: ReportTypeViewFieldOtherFilter['comparator']; type: ReportTypeViewFieldOtherFilter['type']; };

export type SecondaryFilter = SecondaryTextual | SecondaryBoolean | SecondaryNumeric | SecondarySignature | SecondaryEquipment | SecondaryOther;
